import $ from 'jquery';

class GoogleMap {
  constructor() {
    this.maps = document.querySelectorAll('.js-google-map');

    if (!this.maps.length) {
      return;
    }

    this.createMap();
  }

  createMap() {
    this.maps.forEach(el => {
      const map = $(el);
      const address = map.data('map-address');

      if (
        !address.trim().length ||
        typeof map.data('map-address') === 'undefined'
      ) {
        map.hide();
        return;
      }

      // const url = `//www.google.com/maps/embed/v1/place?key=&q=${address}`;
      const url = `//maps.google.com/maps?f=q&source=s_q&hl=en&geocode=&q=${address}&aq=&ie=UTF8&hq=&hnear=${address}&z=14&iwloc=near&output=embed`;

      const iframe = $('<iframe></iframe>', {
        width: '100%',
        height: '100%',
        src: encodeURI(url),
        frameborder: 0,
      });

      map.html(iframe);
    });
  }
}

export default GoogleMap;



// WEBPACK FOOTER //
// ./src/scripts/modules/google-map.js